<script>
import Layout from "@/router/layouts/main";
import { mapState } from "vuex";
import { api } from "@/state/services";
import Avatar from "@/components/widgets/avatar";

export default {
  locales: {
    pt: {
      'My Account': 'Minha Conta',
      'Username': 'Usuário',
      'Name': 'Nome',
      'Cellphone': 'Celular',
      'Password': 'Senha',
    },
    es: {
      'My Account': 'Mi Cuenta',
      'Username': 'Nombre de Usuario',
      'Name': 'Nombre',
      'Cellphone': 'Celular',
    }
  },
  components: {
    Layout,
    Avatar
  },
  computed: {
    ...mapState({
      account: state => state.account
    })
  },
  data() {
    return {
      change: {
        step: 1,
        loading: false,
        password: "",
        cellphone: "",
        codeOld: "",
        codeNew: "",
        numbers: { current: "", new: "" },
      },
    };
  },
  methods: {
    changeReset() {
      this.change = {
        step: 1,
        loading: false,
        password: "",
        cellphone: "",
        codeOld: "",
        codeNew: "",
        numbers: { current: "", new: "" },
      };
    },
    changeSend() {
      if (!this.change.password) {
        this.$toast.error('Preencha todos os campos obrigatórios.');
        return;
      }

      this.change.loading = true;

      api
        .post("user/cellphone/change", {
          password: this.change.password,
        })
        .then((response) => {
          if (response.data.status == "success") {
            this.$toast.success(response.data.message);

            this.change.numbers.current = response.data.cellphone.current;
            this.change.password = "";
            this.change.step = 2;
          } else {
            this.$toast.error(response.data.message);
          }

          this.change.loading = false;
        })
        .catch((error) => {
          if (error) {
            this.change.loading = false;
          }
        });
    },
    changeOld() {
      if (this.change.codeOld.length != 6 || this.change.cellphone.replace(/\D/g, "").length != 11) {
        this.$toast.error('Preencha todos os campos obrigatórios.');
        return;
      }

      this.change.loading = true;

      api
        .post("user/cellphone/change/old", {
          code_old: this.change.codeOld,
          cellphone: "+55." + this.change.cellphone.replace(/\D/g, ""),
        })
        .then((response) => {
          if (response.data.status == "success") {
            this.$toast.success(response.data.message);

            this.change.numbers.new = response.data.cellphone.new;
            this.change.codeOld = "";
            this.change.step = 3;
          } else {
            this.$toast.error(response.data.message);
          }

          this.change.loading = false;
        })
        .catch((error) => {
          if (error) {
            this.change.loading = false;
          }
        });
    },
    changeConfirm() {
      if (this.change.codeNew.length != 6) {
        this.$toast.error('Digite o código de 6 dígitos.');
        return;
      }

      this.change.loading = true;

      api
        .post("user/cellphone/change/verify", {
          code_new: this.change.codeNew,
        })
        .then((response) => {
          if (response.data.status == "success") {
            this.$toast.success(response.data.message);

            this.$bvModal.hide("modal-cellphone");
            api.get("user").then((user) => {
              if (user.data.status == "success") {
                this.$store.state.account.user = user.data.user;
              }
            });
          } else {
            this.$toast.error(response.data.message);
          }

          this.change.loading = false;
        })
        .catch((error) => {
          if (error) {
            this.change.loading = false;
          }
        });
    },
  },
  mounted() {
  },
};
</script>

<template>
  <Layout>
    <div class="page-title-box d-md-flex justify-content-between">
      <div>
        <h3>{{ t('My Account') }}</h3>
        <p></p>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-md-4">
            <Avatar></Avatar>
          </div>
          <div class="col-md-8 pt-md-5">
            <div class="row pt-3 pb-0 pl-3 pr-3">
              <div class="col-md-6 text-center-sm">
                <p class="mb-0 text-uppercase font-weight-normal card-title-desc">{{ t('Username') }}</p>
                <p class="mb-3 font-weight-normal notranslate">{{ account.user.username }}</p>
              </div>
              <div class="col-md-6 text-center-sm">
                <p class="mb-0 text-uppercase font-weight-normal card-title-desc">{{ t('Name') }}</p>
                <p class="mb-3 font-weight-normal notranslate">{{ account.user.name }}</p>
              </div>
              <div class="col-md-6 text-center-sm">
                <p class="mb-0 text-uppercase font-weight-normal card-title-desc">{{ t('Email') }}</p>
                <p class="mb-3 font-weight-normal notranslate">{{ account.user.email.address }}</p>
              </div>
              <div class="col-md-6 text-center-sm">
                <p class="mb-0 text-uppercase font-weight-normal card-title-desc">{{ t('Cellphone') }}</p>
                <p class="mb-1 font-weight-normal notranslate">{{ account.user.cellphone }}</p>
                <b-button v-if="account.user.cellphone_status == 'verified'" v-b-modal.modal-cellphone variant="outline-default" class="mb-3">
                  Alterar celular
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="modal-cellphone" title="Alterar celular" hide-footer centered @hidden="changeReset">
      <div v-if="change.step == 1">
        <p class="text-muted">Para alterar o número, primeiro enviamos um código para o seu número atual para autorizar a troca.</p>
        <b-form-group label="Senha atual" label-for="change-password">
          <b-form-input id="change-password" v-model="change.password" type="password" autocomplete="current-password"></b-form-input>
        </b-form-group>
        <p class="text-muted font-size-12">Sem acesso ao seu número atual? Entre em contato com o nosso suporte.</p>
        <b-button :disabled="change.loading" variant="default" class="btn-lg btn-block" @click="changeSend">
          Enviar código
          <b-spinner v-if="change.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
        </b-button>
      </div>
      <div v-else-if="change.step == 2">
        <p class="text-muted">Agora informe o código enviado para o seu número atual e o novo celular.</p>
        <b-form-group :label="'Código enviado para o seu número atual (' + change.numbers.current + ')'" label-for="code-old">
          <b-form-input id="code-old" v-model="change.codeOld" type="text" inputmode="numeric" maxlength="6" autocomplete="off"></b-form-input>
        </b-form-group>
        <b-form-group label="Novo celular" label-for="change-cellphone">
          <b-form-input id="change-cellphone" v-model="change.cellphone" v-mask="'(##) #####-####'" type="text" inputmode="numeric" placeholder="(11) 99999-9999"></b-form-input>
        </b-form-group>
        <b-button :disabled="change.loading" variant="default" class="btn-lg btn-block" @click="changeOld">
          Continuar
          <b-spinner v-if="change.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
        </b-button>
      </div>
      <div v-else>
        <p class="text-muted">Digite o código enviado para o seu número novo para concluir a troca.</p>
        <b-form-group :label="'Código enviado para o seu número novo (' + change.numbers.new + ')'" label-for="code-new">
          <b-form-input id="code-new" v-model="change.codeNew" type="text" inputmode="numeric" maxlength="6" autocomplete="off"></b-form-input>
        </b-form-group>
        <b-button :disabled="change.loading" variant="default" class="btn-lg btn-block" @click="changeConfirm">
          Confirmar alteração
          <b-spinner v-if="change.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
        </b-button>
      </div>
    </b-modal>
  </Layout>
</template>
